import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import NoImage from "../../../assets/img/Letflow/no-image.jpg";
import PlaylistImage from "../../../assets/img/Letflow/playlist.jpg";
import {Link} from "react-router-dom";
import {request} from "../../../api-client";
import PrevArrow from "../../../components/Letflow/Arrows/PrevArrow";
import NextArrow from "../../../components/Letflow/Arrows/NextArrow";
import {GAevent, homePathGenerator, slugify} from "../../../api-client/core/authentication/utils";
import ContentCreationPlayer from "../../../components/Letflow/ContentCreationPlayer";
import Delete from "@material-ui/icons/Delete";
import { Share } from "@material-ui/icons";
import ShareOnSocials from "../../../components/Letflow/ShareOnSocials";
import { IconButton, Tooltip } from "@material-ui/core";
import localization from "../../../config/localization";

class FavoritesCarousel extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      elements: props.elements || [],
      showContentCreationDialog: false,
      currentPlayingContent: {},
      showShareDialog: false,
      shareLink: "",
      shareToken: "",
    }
  }

  makeImage = (element, type) => {
    let image;
    if (type === 'playlists') {
      if (element.created_by_admin) {
        if (element.image) {
          image = request.file.image.makeCroppedUrl(element.image.id, 400, 400)
        } if (element.featuredImage && element.featuredImage.image) {
          image = request.file.image.makeCroppedUrl(element.featuredImage.image.id, 400, 400)
        } else {
          image = PlaylistImage
        }
      } else {
        if (element.featuredImage && element.featuredImage.image) {
          image = request.file.image.makeCroppedUrl(element.featuredImage.image.id, 400, 400)
        } else {
          image = PlaylistImage
        }
      }
    }  else if (element.image) {
      image = request.file.image.makeCroppedUrl(element.image.id, 400, 400)
    } else {
      image = NoImage
    }
    return image
  };

  removeFromFavorite = (id, type) => {
    this.setState({elements: this.state.elements.filter(element => element.id !== id)});
    switch (type) {
      case 'album':
        request.favorite.remove(id);
        break;
      case 'artist':
        request.artistFavorite.remove(id);
        break;
      case 'playlists':
        request.playlist.removeFavorite(id);
        break;
      case 'speaker':
        request.speakerFavorite.remove(id);
        break;
      case 'content_creator':
        request.contentCreatorFavorite.remove(id);
        break;
      case 'video_content_creation':
        request.contentCreationFavorite.remove(id);
        break;
    }
  };

  renderShareDialog = () =>
    <ShareOnSocials
      show={this.state.showShareDialog}
      handleClose={() => this.setState({showShareDialog: false})}
      url={this.state.shareLink}
      darkMode
      shareToken={this.state.shareToken}
    />

  render() {
    const {slidesToShow, type} = this.props;
    const {elements} = this.state;
    let settings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToShow,
      initialSlide: 0,
      prevArrow: <PrevArrow/>,
      nextArrow: <NextArrow/>,
      responsive: [
        {
          breakpoint: 1500,
          settings: {
            slidesToShow:slidesToShow === 6 ? 5 : 4,
            slidesToScroll: slidesToShow === 6 ? 5 : 4,
          }
        },
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          }
        },
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            initialSlide: 3,

          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: false
          }
        }
      ]
    };


    return (
      <section data-max-per-row="4" style={{ marginBottom: "0px", paddingBottom: "10px", paddingLeft: 0, paddingRight: 0 }} className="category">
        <ContentCreationPlayer
          show={this.state.showContentCreationDialog}
          currentContentCreation={this.state.currentPlayingContent}
          handleClose={() => this.setState({showContentCreationDialog: false,currentPlayingContent: {}})}
        />
        {this.renderShareDialog()}
        <div className="row-category" style={{ position: "relative", float: "left", width: "100%" }}>
          <div style={{ width: "100%", float: "left", position: "relative" }}>
            <div className="carousel-wrapper">
              <Slider {...settings}>
                {elements.map((element) => {
                  return (
                    <article style={{ width: '100%' }} className="album-grid-cell is-collapsed opacity1">
                      <div className="album-grid-img" style={{ width: "100%", padding: '10px' }}>
                        <Link
                          to={homePathGenerator(`contenido/${element.id}-${slugify(element.name)}`)}
                        >
                          <div className="category-item fav-container" style={{ width: "100%", cursor: 'pointer', borderRadius: '50%' }}>
                            <div className="photo-container">
                              <div className="photo" style={{backgroundImage: `url(${this.makeImage(element, type)})`}} >
                              </div>
                            </div>
                            <div className="info">
                              <div className="title">
                                {element.name}
                              </div>
                            </div>
                            <div className="icons">
                              <div className='list'>
                                <IconButton
                                  style={{height: 30,marginLeft: 10,top: -3,width: 30}}
                                  onClick={(e) => {
                                    this.removeFromFavorite(element.id, type);
                                    e.preventDefault()
                                  }}
                                >
                                  <Tooltip placement="bottom" title={localization.get("favorite.remove")} >
                                    <Delete/>
                                  </Tooltip>
                                </IconButton>
                              </div>
                              <div className='list'>
                                <IconButton
                                  style={{height: 30,marginLeft: 10,top: -3,width: 30}}
                                  onClick={(e) => {
                                    request.contentCreator.share(element.id)
                                      .then(response => this.setState({
                                        showShareDialog: true,
                                        shareLink: `${window.location.protocol}//${window.location.hostname}/public/content_creators/${response.code}`,
                                        shareToken: response.code
                                      }))
                                    e.preventDefault();
                                  }}
                                >
                                  <Tooltip placement="bottom" title={localization.get("share")} >
                                    <Share style={{fontSize: 20}}/>
                                  </Tooltip>
                                </IconButton>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    </article>
                  )
                })}
              </Slider>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

FavoritesCarousel.defaultProps = {
  slidesToShow: 5,
  type: 'album'
};



export default FavoritesCarousel
